import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Organizations } from './pages/Organizations';
import { OrganizationDetail } from './pages/OrganizationDetail';
import { Users } from './pages/Users';
import { Applications } from './pages/Applications';
import { AdminUsers } from './pages/AdminUsers';
import { DatalakeStatus } from './pages/DatalakeStatus';
import { DatalakeRuns } from './pages/DatalakeRuns';
import { DatalakeCoverage } from './pages/DatalakeCoverage';
import { DatalakeCustomers } from './pages/DatalakeCustomers';
import { ReportsMonitor } from './pages/ReportsMonitor';
import { Reporting } from './pages/Reporting';
import { ReportDetail } from './pages/ReportDetail';
import { ReportPreviewWindow } from './pages/ReportPreviewWindow';
import { Exporter } from './pages/Exporter';
import { AppStreamSessions } from './pages/AppStreamSessions';
import { AppStreamUsage } from './pages/AppStreamUsage';
import { SmsNumbers } from './pages/SmsNumbers';
import { SmsReport } from './pages/SmsReport';
import { Cellular } from './pages/Cellular';
import { CellularNotices } from './pages/CellularNotices';
import { Gateways } from './pages/Gateways';
import { GatewayHistory } from './pages/GatewayHistory';
import { Roles } from './pages/Roles';
import { AuditLog } from './pages/AuditLog';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/reporting/preview"
        element={
          <ProtectedRoute requiredPermission="reporting.preview">
            <ReportPreviewWindow />
          </ProtectedRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="organizations/:id" element={<OrganizationDetail />} />
        <Route path="users" element={<Users />} />
        <Route path="applications" element={<Applications />} />
        <Route path="datalake" element={<Navigate to="/datalake/status" replace />} />
        <Route path="datalake/status" element={<DatalakeStatus />} />
        <Route path="datalake/runs" element={<DatalakeRuns />} />
        <Route path="datalake/customers" element={<DatalakeCustomers />} />
        <Route path="datalake/coverage" element={<DatalakeCoverage />} />
        <Route path="reporting" element={<Reporting />} />
        <Route path="reporting/status" element={<ReportsMonitor />} />
        <Route path="reporting/:reportId" element={<ReportDetail />} />
        <Route
          path="exporter"
          element={
            <ProtectedRoute requiredPermission="exporter.read">
              <Exporter />
            </ProtectedRoute>
          }
        />
        <Route path="workspaces" element={<Navigate to="/workspaces/sessions" replace />} />
        <Route
          path="workspaces/sessions"
          element={
            <ProtectedRoute requiredPermission="appstream.read">
              <AppStreamSessions />
            </ProtectedRoute>
          }
        />
        <Route
          path="workspaces/usage"
          element={
            <ProtectedRoute requiredPermission="appstream.read">
              <AppStreamUsage />
            </ProtectedRoute>
          }
        />
        <Route path="sms" element={<Navigate to="/sms/numbers" replace />} />
        <Route
          path="sms/numbers"
          element={
            <ProtectedRoute requiredPermission="sms.read">
              <SmsNumbers />
            </ProtectedRoute>
          }
        />
        <Route
          path="sms/report"
          element={
            <ProtectedRoute requiredPermission="sms.read">
              <SmsReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="cellular"
          element={
            <ProtectedRoute requiredPermission="cellular.read">
              <Cellular />
            </ProtectedRoute>
          }
        />
        <Route
          path="cellular/notices"
          element={
            <ProtectedRoute requiredPermission="cellular.read">
              <CellularNotices />
            </ProtectedRoute>
          }
        />
        <Route
          path="gateways/history"
          element={
            <ProtectedRoute requiredPermission="gateway.read">
              <GatewayHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="gateways"
          element={
            <ProtectedRoute requiredPermission="gateway.read">
              <Gateways />
            </ProtectedRoute>
          }
        />
        <Route path="monitoring/datalake" element={<Navigate to="/datalake/status" replace />} />
        <Route path="monitoring/reports" element={<Navigate to="/reporting/status" replace />} />
        <Route
          path="admin/users"
          element={
            <ProtectedRoute requiredPermission="admin.users.read">
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/roles"
          element={
            <ProtectedRoute requiredPermission="admin.roles.read">
              <Roles />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/audit"
          element={
            <ProtectedRoute requiredPermission="audit.read">
              <AuditLog />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}
